module.exports = __webpack_public_path__ + "static/media/chalkboard-green-pattern-01.e70a1ada.jpg";